import { defineSlotRecipe } from "@chakra-ui/react";

export const toastSlotRecipe = defineSlotRecipe({
  slots: ["root", "indicator", "title", "description"],
  base: {
    root: {
      display: "flex",
      alignItems: "flex-start",
      gap: "3",
      px: "4",
      py: "3",
      w: "100",
      borderWidth: "1px",
      borderRadius: "toast.success",
      boxShadow: "md",
      "&[data-type=success]": {
        bg: "bg.toast.success",
        borderColor: "border.toast.success",
        color: "text.toast.success",
      },
      "&[data-type=error]": {
        bg: "bg.toast.error",
        borderColor: "border.toast.error",
        color: "text.toast.error",
      },
      "&[data-type=info]": {
        bg: "bg.toast.info",
        borderColor: "border.toast.info",
        color: "text.toast.info",
      },
      "&[data-type=warning]": {
        bg: "bg.toast.warning",
        borderColor: "border.toast.warning",
        color: "text.toast.warning",
      },
    },
    indicator: {
      fontSize: "lg",
      flexShrink: 0,
      mt: "0.5",
      "[data-type=success] &": {
        color: "text.toast.success",
      },
      "[data-type=error] &": {
        color: "text.toast.error",
      },
      "[data-type=info] &": {
        color: "text.toast.info",
      },
      "[data-type=warning] &": {
        color: "text.toast.warning",
      },
    },
    title: {
      fontWeight: "semibold",
      fontSize: "sm",
      lineHeight: "1.4",
      "[data-type=success] &": {
        color: "text.toast.success",
      },
      "[data-type=error] &": {
        color: "text.toast.error",
      },
      "[data-type=info] &": {
        color: "text.toast.info",
      },
      "[data-type=warning] &": {
        color: "text.toast.warning",
      },
    },
    description: {
      fontSize: "xs",
      lineHeight: "1.4",
      opacity: 0.9,
      "[data-type=success] &": {
        color: "text.toast.success",
      },
      "[data-type=error] &": {
        color: "text.toast.error",
      },
      "[data-type=info] &": {
        color: "text.toast.info",
      },
      "[data-type=warning] &": {
        color: "text.toast.warning",
      },
    },
  },
});
